import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const videoPlayerLogsEnabled = isFeature('video-player-logs-enabled');
